/* eslint-disable */
import { store } from '../../store'
import { http } from '../../main'
import { httpgst } from '../../main'

// initial state
const state = {}

// getters
const getters = {}

// actions
const actions = {
  async getVehicles({ commit }, ctx) {
    try {
      const url = `api/vehicle`
      const options = {
        headers: {
          'Content-Type': 'application/json'
        }
      }
      httpgst.defaults.headers.common['Authorization'] =
        'Bearer ' + store.state.userState.access_token

      const response = await httpgst.get(url, options)
      ctx.vehicles = response.data.data
    } catch (error) {
      console.log(error)
      const message = error.response.data.message
      ctx.showNotification(message, 'error', 3000)
    }
  },

  async createVehicle({ commit }, { ctx, payload }) {
    try {
      ctx.loadingAdd = true
      const url = `api/vehicle`
      const options = {
        headers: {
          'Content-Type': 'application/json'
        }
      }
      httpgst.defaults.headers.common['Authorization'] =
        'Bearer ' + store.state.userState.access_token

      const response = await httpgst.post(url, payload, options)
      const message = response.data.message
      ctx.showNotification(message, 'success', 3000)
    } catch (error) {
      console.log(error)
      const message = error.response.data.message
      ctx.showNotification(message, 'error', 3000)
    } finally {
      ctx.loadingAdd = false
      ctx.dialogAdd = false
      ctx.init()
    }
  },

  async updateVehicle({ commit }, { ctx, payload, id }) {
    try {
      ctx.loadingEdit = true
      const url = `api/vehicle/${id}`
      const options = {
        headers: {
          'Content-Type': 'application/json'
        }
      }
      httpgst.defaults.headers.common['Authorization'] =
        'Bearer ' + store.state.userState.access_token

      const response = await httpgst.put(url, payload, options)
      const message = response.data.message
      ctx.showNotification(message, 'success', 3000)
    } catch (error) {
      console.log(error)
      const message = error.response.data.message
      ctx.showNotification(message, 'error', 3000)
    } finally {
      ctx.loadingEdit = false
      ctx.dialogEdit = false
      ctx.init()
    }
  },

  async deleteVehicle({ commit }, { ctx, id }) {
    try {
      ctx.loadingDelete = true
      const url = `api/vehicle/${id}`
      const options = {
        headers: {
          'Content-Type': 'application/json'
        }
      }
      httpgst.defaults.headers.common['Authorization'] =
        'Bearer ' + store.state.userState.access_token

      const response = await httpgst.delete(url, options)
      const message = response.data.message
      ctx.showNotification(message, 'success', 3000)
      ctx.init()
    } catch (error) {
      console.log(error)
      const message = error.response.data.message
      ctx.showNotification(message, 'error', 3000)
    } finally {
      ctx.loadingDelete = false
      ctx.dialogDelete = false
    }
  }
}

// mutations
const mutations = {}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/vehicles.js